import programListStore from '@modules/program/program-list-store';
import programViewStore from '@modules/program/program-view-store';
import programImporterStore from '@modules/program/program-importer-store';
import programFormStore from '@modules/program/program-form-store';
import programDestroyStore from '@modules/program/program-destroy-store';

export default {
  namespaced: true,

  modules: {
    destroy: programDestroyStore,
    form: programFormStore,
    list: programListStore,
    view: programViewStore,
    importer: programImporterStore,
  },
};
